import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  stepContainer: {
    '@media(max-width: 768px)': {
      display: 'flex'
    }
  },
  stepWrapper: {
    marginBottom: 10,
    '&:after': {
      background: '#CCC',
      content: 'close-quote',
      display: 'block',
      height: 25,
      marginLeft: 12,
      marginTop: 10,
      width: 1
    },
    '&:last-child': {
      '&:after': {
        display: 'none'
      }
    },
    '@media(max-width: 768px)': {
      position: 'relative',
      width: 'inherit',
      '&:after': {
        height: 1,
        left: 'calc(50% + 10px)',
        position: 'absolute',
        top: 5,
        width: 'calc(100% - 45px)'
      }
    },
    '@media(max-width: 620px)': {
      '&:after': {
        left: 'calc(50% + 5px)',
        top: 1,
        width: 'calc(100% - 35px)'
      }
    }
  }
});
